import { connect } from 'react-redux';
import { change as changeFormValue } from 'redux-form';
import { getTravelerMealPreferenceList } from '../utils/mealUtil';
import { getSelected } from '../../single-choice/utils/selection';
import { getSelectedTraveler, getTravelerField, hasAnyTravelerSelected, getTravelersWithChoice, getTravelerChoice } from '../utils/smallMealUtil';
import { MEAL } from '../../products';
import SmallMealContent from '../components/SmallMealContent';
import { getTravelerNames } from '../../common/utils/travelerNames';
const {
  name: PRODUCT_NAME
} = MEAL;
const updateTotalPrice = (dispatch, {
  form
}) => priceRaw => {
  dispatch(changeFormValue(form, `${PRODUCT_NAME}.value.priceRaw`, priceRaw));
};
const selectMealTraveler = (id, form, value, dispatch) => {
  const travelerField = getTravelerField(id, PRODUCT_NAME);
  dispatch(changeFormValue(form, `${travelerField}.selected`, value));
};
const selectProduct = (dispatch, {
  form
}) => newValue => dispatch(changeFormValue(form, `${PRODUCT_NAME}.value.value`, newValue));
const selectTraveler = (dispatch, {
  form
}) => (id, value) => {
  selectMealTraveler(id, form, value, dispatch);
};
const selectAllTravelers = (dispatch, {
  form
}) => (travelers, value) => {
  travelers.forEach(({
    travelerId,
    hasChoice
  }) => {
    if (hasChoice) {
      selectMealTraveler(travelerId, form, value, dispatch);
    }
  });
};
const updateInitialValues = (dispatch, {
  form
}) => preSelectedTravelerChoices => {
  dispatch(changeFormValue(form, `${PRODUCT_NAME}.travelers`, preSelectedTravelerChoices));
};
const mapStateToProps = (state, {
  form,
  order,
  travelerDescription,
  noOptionLabel
}) => {
  const travelerNames = getTravelerNames(form, state, order === null || order === void 0 ? void 0 : order.travelers);
  const travelersWithChoice = getTravelersWithChoice(PRODUCT_NAME, form)(state);
  const smallMealTravelers = getTravelerMealPreferenceList(order, travelerNames, travelerDescription, noOptionLabel).map(traveler => {
    const travelerId = traveler.travelerId || '';
    const isSelected = getSelectedTraveler(PRODUCT_NAME, form, travelerId)(state);
    const hasChoice = travelersWithChoice.includes(travelerId);
    const choice = getTravelerChoice(PRODUCT_NAME, form, travelerId)(state);
    return {
      ...traveler,
      choice,
      travelerId,
      isSelected,
      hasChoice
    };
  });
  return {
    cardSelection: getSelected(PRODUCT_NAME, form)(state),
    hasAnySelected: hasAnyTravelerSelected(PRODUCT_NAME, form)(state),
    smallMealTravelers
  };
};
const mapDispatchToProps = (dispatch, form) => ({
  selectProduct: selectProduct(dispatch, form),
  selectAllTravelers: selectAllTravelers(dispatch, form),
  selectTraveler: selectTraveler(dispatch, form),
  updateInitialValues: updateInitialValues(dispatch, form),
  updateTotalPrice: updateTotalPrice(dispatch, form)
});
export default connect(mapStateToProps, mapDispatchToProps)(SmallMealContent);
//# sourceMappingURL=SmallMealContainer.js.map